<template>
	<div class="page">
		<top-header></top-header>
		<div class="cont-box">
		<!-- <b-container fluid style="margin-top:5%;">
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3>Control Panel {{is_connected}}</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill class="mr-2" @click="showAddModal()">Add CCMS | DCU</b-button>
					<b-button variant="dark" pill  @click="downloadcsv()">Export</b-button>
				</b-col>
			</b-row>
		</b-container> -->
		
		<b-container fluid style="margin-top:5%;">
			<h5 class="pt-3">Control Panel {{is_connected}}</h5>
			
			<b-form class="p-3" id="imeischeduleForm" @submit="imeischeduleForm">
				<b-row class="d-flex justify-content-center" v-if="show_edit==1">									
					<b-col >					
						<b-form-group 
						label="IMEI Number" 
						label-for="fp-input" 
						label-cols="0" 
						label-size="sm" 
						label-align-sm="left"
							>
							<b-form-input 
							type="number" 
							langth="15" 
								id="fp-input"
								placeholder="IMEI No." 
								required 
								size="sm" 
								max-length="2" 
								v-model="scheduledata.imei_no"
								disabled="disabled"
								></b-form-input>
						</b-form-group>
					</b-col>
					<b-col >	

						<b-form-group
						label="Device Group"
						label-cols="0"
						label-size="sm" 
						label-align-sm="left"
						:disabled="  $session.get('user_info').role ==15"   
						>
						<b-form-select v-model="scheduledata.group_id" @change="setTime" id="groupoption" >
							<b-form-select-option value="0">--- Select Supervisor ---</b-form-select-option>
							<b-form-select-option v-for="(item, index) in grouplist" v-bind:key="index" :value="item.group_id">{{
							item.name}}</b-form-select-option>
						</b-form-select>
						</b-form-group>

					</b-col>
					<b-col>
						<b-form-group
						label="Supervisor"
						label-cols="0"
						label-size="sm" 
						label-align-sm="left"
						:disabled="  $session.get('user_info').role ==15"    
						 
						>
						<b-form-select v-model="scheduledata.supervisor_id"  >
							<b-form-select-option value="0">--- Select Supervisor ---</b-form-select-option>
							<b-form-select-option v-for="item in supervisorlist" v-bind:key="item.supervisor_id" :value="item.supervisor_id">{{
							item.username
							}}</b-form-select-option>
						</b-form-select>
						</b-form-group>
					
					</b-col>
					<b-col >
						<b-form-group 
						id="input-group-2" 
						label="R Phase ON Time" 
						label-for="type-rontime" 
						label-cols="0" 
						label-size="sm" 
						label-align-sm="left"
						
						>
							<b-form-input 
							id="type-rontime" 
							type="time" 
							size="sm" 
							required 
							v-model="scheduledata.on_time"
							disabled="disabled"
							></b-form-input>
						</b-form-group>
						<b-form-group 
						id="input-group-2" 
						label="R Phase OFF Time" 
						label-for="type-rofftime" 
						label-cols="0" 
						label-size="sm" 
						label-align-sm="left" >
							<b-form-input 
							id="type-rofftime" 
							type="time"
							size="sm" 
							required 
							v-model="scheduledata.off_time"
							disabled="disabled"></b-form-input>
						</b-form-group>
					</b-col>
					<!-- <b-col >
						<b-form-group 
						id="input-group-2" 
						label="R Phs. OFF Time" 
						label-for="type-rofftime" 
						label-cols="0" 
						label-size="sm" 
						label-align-sm="left" >
							<b-form-input 
							id="type-rofftime" 
							type="time"
							size="sm" 
							required 
							v-model="scheduledata.off_time"
							disabled="disabled"></b-form-input>
						</b-form-group>
					</b-col> -->
					<b-col >
						<b-form-group 
						id="input-group-2" 
						label="Y Phase ON Time" 
						label-for="type-yontime" 
						label-cols="0" 
						label-size="sm" 
						label-align-sm="left"
						
						>
							<b-form-input 
							id="type-yontime" 
							type="time" 
							size="sm" 
							required 
							v-model="scheduledata.on_time_y"
							disabled="disabled"
							></b-form-input>
						</b-form-group>
						<b-form-group 
						id="input-group-2" 
						label="Y Phase OFF Time" 
						label-for="type-yofftime" 
						label-cols="0" 
						label-size="sm" 
						label-align-sm="left" >
							<b-form-input 
							id="type-yofftime" 
							type="time"
							size="sm" 
							required 
							v-model="scheduledata.off_time_y"
							disabled="disabled"></b-form-input>
						</b-form-group>
					</b-col>
					<!-- <b-col >
						<b-form-group 
						id="input-group-2" 
						label="Y Phs. OFF Time" 
						label-for="type-yofftime" 
						label-cols="0" 
						label-size="sm" 
						label-align-sm="left" >
							<b-form-input 
							id="type-yofftime" 
							type="time"
							size="sm" 
							required 
							v-model="scheduledata.off_time_y"
							disabled="disabled"></b-form-input>
						</b-form-group>
					</b-col> -->

					<b-col >
						<b-form-group 
						id="input-group-2" 
						label="B Phase ON Time" 
						label-for="type-bontime" 
						label-cols="0" 
						label-size="sm" 
						label-align-sm="left"
						
						>
							<b-form-input 
							id="type-bontime" 
							type="time" 
							size="sm" 
							required 
							v-model="scheduledata.on_time_b"
							disabled="disabled"
							></b-form-input>
						</b-form-group>

						<b-form-group 
						id="input-group-2" 
						label="B Phase OFF Time" 
						label-for="type-bofftime" 
						label-cols="0" 
						label-size="sm" 
						label-align-sm="left" >
							<b-form-input 
							id="type-bofftime" 
							type="time"
							size="sm" 
							required 
							v-model="scheduledata.off_time_b"
							disabled="disabled"></b-form-input>
						</b-form-group>
					</b-col>
					<!-- <b-col >
						<b-form-group 
						id="input-group-2" 
						label="B Phase OFF Time" 
						label-for="type-bofftime" 
						label-cols="0" 
						label-size="sm" 
						label-align-sm="left" >
							<b-form-input 
							id="type-bofftime" 
							type="time"
							size="sm" 
							required 
							v-model="scheduledata.off_time_b"
							disabled="disabled"></b-form-input>
						</b-form-group>
					</b-col> -->
				
						<b-col class="col-md-2 col-sm-12 col-xs-12 mt-4">
							<b-button type="submit" size="sm" variant="dark"  style="    margin-top: 7px !important;" >{{submitBtn}}</b-button>
							<b-button  size="sm"  class="ml-2 mt-2"  @click="show_edit=0"> Cancel </b-button>
						</b-col>
					
						<!-- <b-col class="col-md-2 col-sm-12 col-xs-12 mt-4 text-center">
							<b-button size="sm" class="mt-2" variant="dark"  style="   margin-top: 7px !important;"   v-b-modal.modal-csv >Import CSV </b-button>
							<p><small><b-link href="http://matrixmeters.com/icon/IMEI_schedule.csv" target="_blank">Download Sample</b-link></small></p>
						</b-col> -->
							
				</b-row>
			</b-form>

		<b-row>
			

			<div>
			

			<b-modal id="modal-csv" title="Upload CSV File" hide-footer>
				<p class="my-4">First download sample csv file and upload alike as</p>
				<!-- <input type="file" id="file" ref="file" class="" />
				<button @click="csvtojson()" class="btn btn-warning" style="padding: 0px;">Upload</button> -->

				<!-- <b-form-group label-cols-lg="2"> -->
				<b-input-group cols-lg="10">
				<b-input-group-prepend is-text>
					CSV
					<!-- <b-icon icon="filetype-csv"></b-icon> -->
				</b-input-group-prepend>
				<b-form-file type="file" id="file" ref="file" accept="csv/*"></b-form-file>
				</b-input-group>
				<div cols-lg="2" class="text-center mt-2">
				<b-button @click="csvtojson()"  variant="warning" size="sm" class="text-white" style="width: 120px; font-weight: 600;" >
					Upload
				</b-button>
				</div>

			</b-modal>
			</div>
		</b-row>

			
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div style="border-top: 3px solid #333; border-radius: 5px; min-height: 100px; background-color: #FFF; display: flex; flex-direction: column;">
						<b-row class="mt-4 px-3 mb-3">
							<b-col lg="6">
								<label class="mr-2">Show</label>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>

								<span class="ml-3 mr-2">Filters</span>
								<VSelect v-model="groupfilter" :options="groupfilterlist" :searchable="true" defaultTitle="All Group" size="sm" class=" w-20 custom-select custom-select-sm" @input="onFilterChangegroup()"></VSelect>

                      			<VSelect v-model="supervisorfilter" :options="supervisorfilterlist" :searchable="true" defaultTitle="All Supervisor" size="sm" class=" w-20 custom-select custom-select-sm" @input="onFilterChangesupervisor()"></VSelect>


							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group 
								label="Filter" 
								label-cols-sm="3" 
								label-align-sm="right" 
								label-size="sm" 
								label-for="filterInput" 
								class="mb-0"
								>
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="12"> 
								<b-table show-empty sticky-header small striped outlined stacked="md"
								 :items="filteredrecords" 
								 :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(imei_no)="row">
										<b-link :href="'/device-data/'+row.value">{{row.value}}</b-link>
									</template>
									<template v-slot:cell(location)="row">
										<span :id="'l-'+row.item.id" pill variant="success">{{row.value}}</span>
										<b-popover
											:target="`l-${row.item.id}`"
											title="Location"
											triggers="hover focus">
											{{row.item.location}}													
										</b-popover>
									</template>
									<template v-slot:cell(on_time)="row">
										{{ row.value===null || row.value==='' ?'00:00':row.value }} 
									</template>
									<template v-slot:cell(off_time)="row">
										{{ row.value===null || row.value==='' ?'00:00':row.value }} 
									</template>
									<template v-slot:cell(actions)="row">
									<b-button
									pill  
									variant="primary" 
									class="mr-1 icon-btn"  
									@click="editSchedule(row.item.imei_no, row.item.on_time,row.item.off_time,row.item.on_time_y,row.item.off_time_y,row.item.on_time_b,row.item.off_time_b,row.item.group_id,row.item.supervisor_id,)" size="sm"><b-icon icon="pencil" font-scale="1" 
									></b-icon></b-button>
								<!-- <b-button pill variant="success" class="mr-1" size="sm" ><b-icon icon="power" @click="sendCommand('ON', row.item.imei_no)"></b-icon> ON</b-button>							
								<b-button pill variant="danger" class="mr-1" size="sm" ><b-icon icon="power" @click="sendCommand('OFF', row.item.imei_no)"></b-icon> OFF</b-button> -->
						
								</template>
							</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3 mb-3">
							<b-col lg="6">
								<span class="mr-2">Showing {{(currentPage-1)*perPage}} to {{currentPage*perPage}} of {{filteredrecords.length}} entries</span>
							</b-col>
							<b-col lg="6">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</b-container>		
		<b-container fluid class="m-2 pt-2 pb-2">
			<b-card header-tag="header" class="info-box mb-3 h-100" header-bg-variant="transparent">
				<b-card-text>
					<b-row>
						<b-col><h6 class="mt-2 text-left text-bold">RTC Command</h6></b-col>
						<b-col>	<b-form-input v-model="rtc.uniq_id" placeholder="Unique ID"></b-form-input></b-col>
						<b-col><b-form-input  v-model="rtc.value" required></b-form-input></b-col>
						<b-col><b-button size="sm" class="mt-2" variant="dark" @click="setRTC()">Submit</b-button></b-col>
					</b-row>
				</b-card-text>
			</b-card>

			
					<!--<b-col>
						<b-card header-tag="header" class="info-box mb-3 h-100" header-bg-variant="transparent">
							<b-card-title class="mt-1"><h6 class="mb-0 text-left text-bold">RTC Command</h6></b-card-title>
							<b-card-text>
								<b-form-input v-model="rtc.uniq_id" placeholder="Unique ID"></b-form-input>
								<b-form-input class="mt-3" v-model="rtc.value" required></b-form-input>
								<b-button size="sm" class="mt-2" variant="dark" @click="setRTC()">Submit</b-button>
							</b-card-text>
						</b-card>
					</b-col>
					<b-col>
						<b-card class="info-box mb-3 h-100" header-bg-variant="transparent">
							<b-card-title class="mt-1"><h6 class="mb-0 text-left text-bold">Light ON/OFF</h6></b-card-title>
							<b-card-text>
								<b-form-input v-model="light.uniq_id" placeholder="Unique ID"></b-form-input>
								<b-form-select class="mt-3" v-model="light.value">
									 <b-form-select-option value="LIGHTOF">OFF</b-form-select-option>
									<b-form-select-option value="LIGHTON">ON</b-form-select-option>
									<b-form-select-option value="4C494748544F46">OFF</b-form-select-option>
									<b-form-select-option value="4C494748544F4E">ON</b-form-select-option>
								</b-form-select>
								<b-button size="sm" class="mt-2" variant="dark" @click="setLight()">Submit</b-button>
							</b-card-text>
						</b-card>
					</b-col>
					<b-col>
						<b-card header-tag="header" class="info-box mb-3 h-100" header-bg-variant="transparent" >
							<b-card-title class="mt-1"><h6 class="mb-0 text-left text-bold">DOTOD Command</h6></b-card-title>
							<b-card-text>
								<b-form-input v-model="dotod.uniq_id" placeholder="Unique ID"></b-form-input>
								<b-form-input class="mt-3" v-model="dotod.time1" required placeholder="HHMM"></b-form-input>
								<b-form-input class="mt-3" v-model="dotod.time2" required placeholder="HHMM"></b-form-input>
								<b-button size="sm" class="mt-2" variant="dark" @click="ok()">Submit</b-button>
							</b-card-text>
						</b-card>
					</b-col>
					<b-col>
						<b-card header-tag="header" class="info-box mb-3 h-100" header-bg-variant="transparent">
							<b-card-title class="mt-1"><h6 class="mb-0 text-left text-bold">Packet Time</h6></b-card-title>
							<b-card-text>
								<b-form-input v-model="pkt.uniq_id" placeholder="Unique ID"></b-form-input>
								<b-form-input class="mt-3" v-model="pkt.value" required placeholder="000"></b-form-input>
								<b-button size="sm" class="mt-2" variant="dark" @click="setPktTime()">Submit</b-button>
							</b-card-text>
						</b-card>
					</b-col>-->
			
		</b-container>
	</div>
	</div>
</template>
<script>
import Papa from "papaparse";
import Header from "@/components/Header.vue";
import VSelect from "vue-select-picker-bootstrap";
export default {
	name: 'Login',
	components: {
		"top-header": Header,
		VSelect
	},
	mounted(){
		this.initload();
		this.initloadMasterDevice();
	},
	sockets: {
        connect() {
			this.is_connected = 'Connected';
			console.log('socket connected');
			this.$socket.emit('getdata', 'data chahiye');
        },
		datarecieved(data){
			console.log('ye le data');
			console.log(JSON.stringify(data));
		},
        disconnect() {
			this.is_connected = 'Disconnected';
			console.log('socket disconnected')
		}
    },
	data() {
		var self = this;

		return{
			email: '',
			password: '', 
			imei_no: '',
			is_connected: '',
			url: self.$session.get('apiurl')+'jhansiapi/dashboard',
			rtc: {'uniq_id':'', 'value':self.$moment().format('DDMMYYHHmmss')},
			light: {'uniq_id':'', 'value':'LIGHTOF'},
			dotod: {'uniq_id':'', 'time1':'', 'time2':''},
			pwm: {'uniq_id':'', 'value':''},
			pkt: {'uniq_id':'', 'time':''},

			/* for Master Device */
			urlUpdateScheduler: self.$session.get('apiurl')+'jhansiapi/update-device-scheduler',
			urlDevicecontroler: self.$session.get('apiurl')+'jhansiapi/device-control',
			urlcsvimport: self.$session.get("apiurl") + "jhansiapi/insert-csv-data",
			imeino: self.$route.params.imeino,
			location: '',
			records: [],
			filteredrecords: [],
			device: {},
			fields: [
				{ key: 'imei_no', label: 'IMEI Number', sortable: true,},
				{ key: 'feeder_pillar_no', label: 'F.No.', sortable: true,},
				{ key: 'location', label: 'Location',  class: 'text-left',
					formatter: (value) => { 
						if(value != null){
							if(value.length > 30){
								return value.substring(0,30)+"...";
							}
							
						}
						return value;
					},
				},
							
				{ key: 'group_name', label: 'Device Group', sortable: true,},
				{ key: 'username', label: 'Supervisor', sortable: true,},
				{ key: 'on_time', label: 'R Phase On Time',sortable: true, class:"text-center" },
				{ key: 'off_time', label: 'R Phase Off Time',sortable: true,class:"text-center"},
				{ key: 'on_time_y', label: 'Y Phase On Time',sortable: true, class:"text-center" },
				{ key: 'off_time_y', label: 'Y Phase Off Time',sortable: true,class:"text-center"},
				{ key: 'on_time_b', label: 'B Phase On Time',sortable: true, class:"text-center" },
				{ key: 'off_time_b', label: 'B Phase Off Time',sortable: true,class:"text-center"},
				{ key: 'actions', label: 'Actions', 'extra':1 },
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			scheduledata:{
				imei_no:'',
				on_time:'',
				off_time:'',
				on_time_y:'',
				off_time_y:'',
				on_time_b:'',
				off_time_b:'',
				group_id:0,
				supervisor_id:0
			},
			supervisorfilter:'all',
			supervisorlist:[],
      		supervisorfilterlist:[],
			groupfilter:'all',
			grouplist:[],
			groupfilterlist:[],
			submitBtn:'Submit',
			csvData: [],
			show_edit:0,
			
		};
	},
	methods: {
		initload(){
			//this.$socket.emit('broadcast', 'hello');
			//this.$socket.emit('broadcast', {'imei': imei_no, command: hexvalue});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		setLight(){
			/* console.log('vijay'+this.light.uniq_id +'-----------'+this.light.value);
			var str = "";
			if(this.light.uniq_id == ''){
				str = this.light.value;
				console.log('str:'+str);
				this.$socket.emit('dcucommand', {'imei': this.imei_no, command: str});
			}else{
				
				str = "CTRL,"+this.light.uniq_id+","+this.light.value;
				console.log('str Else:'+str);
				this.$socket.emit('dcucommand', {'imei': this.imei_no, command: str});
			} */
			var hexvalue = [];

			var optn = this.light.value;
			console.log('optn'+optn);
			for(var i = 0; i<optn.length; i+=2){
			hexvalue.push('0x'+optn.substr(i,2));
			}
			console.log('optn AL:'+hexvalue);
			hexvalue.push(0x0D);
			hexvalue.push(0x0A);
			console.log('hexvalue-fianel:'+hexvalue);

			this.$socket.emit('dcucommand', {'imei': this.imei_no, command: hexvalue});


		},
		setRTC(){
			/* var str = "";
			if(this.rtc.uniq_id == ''){
				str = "RTC,"+this.rtc.value;
				this.$socket.emit('dcucommand', {'imei': this.imei_no, command: str});
			}else{
				str = "CTRL,"+this.rtc.uniq_id+",RTC,"+this.rtc.value;
				this.$socket.emit('dcucommand', {'imei': this.imei_no, command: str});
			} */ 
			/* ======================= */
			//var str = "";
			var imei_no = this.rtc.uniq_id;
			var newdate = this.rtc.value;
			

			if(imei_no == ''){
				//str = "5254432C"+$("#rtdata").val()+'0D0A';
			
				var hexvalue = [0x52,0x54,0x43,0x2C];
				for(var i = 0; i<newdate.length; i+=2){
				hexvalue.push('0x'+newdate.substr(i,2));
				}
				hexvalue.push(0x0D);
				hexvalue.push(0x0A);

				this.$socket.emit('dcucommand', {'imei': imei_no, command: hexvalue});
			}else if(imei_no == 'ffffff' || imei_no == 'FFFFFF'){
				var hexvalue2 = [0x43,0x54,0x52,0x4C,0x2C];
				hexvalue2.push(0x08);
				hexvalue2.push(0x08);
				hexvalue2.push(0x08);
				hexvalue2.push(0x08);
				hexvalue2.push(0x2C,0x52,0x54,0x43,0x2C);
				for(var j = 0; j<newdate.length; j+=2){
					hexvalue2.push('0x'+newdate.substr(j,2));
				}				
				hexvalue2.push(0x0D);
				hexvalue2.push(0x0A);

				this.$socket.emit('broadcast', {'imei': imei_no, command: hexvalue2});
				}else{
				var uniqid = this.rtc.uniq_id;
				var hexcode = this.Pad(this.dec2hex(uniqid), 8);
				var hexvalue3 = [0x43,0x54,0x52,0x4C,0x2C];
				hexvalue3.push('0x'+hexcode.substr(6,2));
				hexvalue3.push('0x'+hexcode.substr(4,2));
				hexvalue3.push('0x'+hexcode.substr(2,2));
				hexvalue3.push('0x'+hexcode.substr(0,2));
				hexvalue3.push(0x2C,0x52,0x54,0x43,0x2C);
				for(var k = 0; k<newdate.length; k+=2){
					hexvalue3.push('0x'+newdate.substr(k,2));
				}
				hexvalue3.push(0x0D);
				hexvalue3.push(0x0A);

				//str = "4354524C2C"+hexuniqid+"2C5254432C"+$("#rtdata").val()+'0D0A';
				this.$socket.emit('ctrlcommand', {'imei': imei_no, command: hexvalue3});
			}

			/* ========================= */
		},
		setDOTOD(){
			var str = "";
			if(this.dotod.uniq_id == ''){
				str = "DOTOD,"+this.dotod.time1+this.dotod.time2;
				this.$socket.emit('dcucommand', {'imei': this.imei_no, command: str});
			}else{
				str = "CTRL,"+this.dotod.uniq_id+",DOTOD,"+this.dotod.time1+this.dotod.time2;
				this.$socket.emit('dcucommand', {'imei': this.imei_no, command: str});
			}
		},
		setPktTime(){
			var str = "";
			if(this.pkt.uniq_id == ''){
				str = "PKTTIME,"+this.pkt.value;
				this.$socket.emit('dcucommand', {'imei': this.imei_no, command: str});
			}else{
				str = "CTRL,"+this.pkt.uniq_id+",PKTTIME,"+this.pkt.value;
				this.$socket.emit('dcucommand', {'imei': this.imei_no, command: str});
			}
		},
		initloadMasterDevice(){
			var self = this;
			self.show_edit=0;
			self.supervisorfilterlist=[];
			self.groupfilterlist=[];
			self.supervisorfilterlist.push({'value':'all','text':'All Supervisor'});
			self.groupfilterlist.push({'value':'all','text':'All group'},{'value':'0','text':'Not Assign'});
			self.axios.post(self.urlDevicecontroler, {
				accesskey: self.$session.get('access_key'),
				imeino: self.imeino
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.device;	
					self.filteredrecords = response.data.result.device;

					self.loading 	= false;
					self.totalRows 	= self.records.length;

					self.supervisorlist = response.data.result.supervisors; 					                
					self.supervisorlist.forEach(function(row){
						var supList ={'value':row.supervisor_id,'text':row.username};
						self.supervisorfilterlist.push(supList);
						
					});

					self.grouplist = response.data.result.device_group; 					                
					self.grouplist.forEach(function(row){
						var supList ={'value':row.group_id,'text':row.name};
						self.groupfilterlist.push(supList);
						
					});
			
				}else{
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});

		},
		imeischeduleForm(e){
			e.preventDefault();
			//console.log(JSON.stringify(this.scheduledata));
			var self = this;
			self.axios.post(self.urlUpdateScheduler, {
				accesskey: self.$session.get('access_key'),
				data: self.scheduledata
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvToast.toast(response.data.message, {
						title: 'Alert',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'success',
						solid: true,
						appendToast: true
                    });
					self.scheduledata.imei_no='';
					self.scheduledata.on_time='';
					self.scheduledata.off_time='';
					self.scheduledata.group_id=0;
					self.scheduledata.supervisor_id=0;
					self.show_edit=0;
					self.initloadMasterDevice();
				}else{
					self.$bvToast.toast(response.data.message, {
						title: 'Alert',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'danger',
						solid: true,
						appendToast: true
                    });
				}
				
			})
			.catch(function (error) {	
				alert(error);
			});

		},
		editSchedule(imei_no,on_time,off_time,on_time_y,off_time_y,on_time_b,off_time_b,group_id,supervisor_id){
			var self =this;
			self.show_edit=1;
			self.scheduledata.imei_no=imei_no;
			if(on_time==null || on_time==''){
				on_time = '00:00';
			}else{				
				on_time = on_time.length==4?'0'+on_time:on_time;
			}

			if(off_time==null ||off_time==''){
				off_time = '00:00';
			}else{			
				off_time = off_time.length==4?'0'+off_time:off_time;
			}


			if(on_time_y==null || on_time_y==''){
				on_time = '00:00';
			}else{				
				on_time_y = on_time_y.length==4?'0'+on_time_y:on_time_y;
			}

			if(off_time_y==null ||off_time_y==''){
				off_time = '00:00';
			}else{			
				off_time_y = off_time_y.length==4?'0'+off_time_y:off_time_y;
			}

			if(on_time_b==null || on_time_b==''){
				on_time = '00:00';
			}else{				
				on_time_b= on_time_b.length==4?'0'+on_time_b:on_time_b;
			}

			if(off_time_b==null ||off_time_b==''){
				off_time = '00:00';
			}else{			
				off_time_b = off_time_b.length==4?'0'+off_time_b:off_time_b;
			}
			
					
			self.scheduledata.on_time		= on_time;			
			self.scheduledata.off_time		= off_time;
			self.scheduledata.on_time_y		= on_time_y;			
			self.scheduledata.off_time_y	= off_time_y;
			self.scheduledata.on_time_b		= on_time_b;			
			self.scheduledata.off_time_b	= off_time_b;
			self.scheduledata.group_id		= group_id;	
			self.scheduledata.supervisor_id	= supervisor_id;	
			self.submitBtn='Update';

		},
		Pad (str, max) {
			str = str.toString();
			return str.length < max ? this.Pad("0" + str, max) : str;
		},
		dec2hex(dec) {
			var number = Number(dec).toString(16).toUpperCase()
			if( (number.length % 2) > 0 ) { number= "0" + number }
			return number;
		},
		/* Upload CSV */
		csvtojson() {
				let csvfile = this.$refs.file.files[0];
				if (csvfile == undefined) {
				alert("Please Select The CSV File For Upload");
				this.csvData = [];
				return;
				}
				let self = this;
				Papa.parse(csvfile, {
				header: true,
				dynamicTyping: true,
				skipEmptyLines: true,
				complete(result) {
					self.csvData = result.data;
					console.log("self.csvData", self.csvData);
					self.axios
					.post(self.urlcsvimport, {
						csvkey: self.csvData,
						accesskey: self.$session.get("access_key"),
					})
					.then(function(response) {
						if (response.data.error == 0 || response.data.error == "0") {
							//console.log("its axios response:");
							self.$bvModal.hide('modal-csv');
								self.$bvToast.toast(response.data.message, {
								title: 'Alert',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'success',
								solid: true,
								appendToast: true
								});
						}else{
							self.$bvToast.toast(response.data.message, {
								title: 'Alert',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'danger',
								solid: true,
								appendToast: true
								});

						}
					})
					.catch(function(error) {
						console.log(error);
					});
				},
				});

				console.log("this.csvData :: ", self.csvData);
			},
			onFilterChangesupervisor(){
				this.supervisorfilter =this.supervisorfilter.value;    
				this.filteredrecords = this.filtersupervisorChange(this.records);			
				this.totalRows = this.filteredrecords.length;
				this.currentPage = 1;

			},  
			filtersupervisorChange(devices){
				var self = this;
				return devices.filter(function (d) { 
				console.log('asdasd'+self.supervisorfilter);
					if(self.supervisorfilter =='all'){
						return d;
					}
					else{          
						if(self.supervisorfilter == d.supervisor_id){						
								return d;							
						}
						
					}
				});
			},
			onFilterChangegroup(){
				this.groupfilter =this.groupfilter.value;    
				this.filteredrecords = this.filtergroupChange(this.records);			
				this.totalRows = this.filteredrecords.length;
				this.currentPage = 1;
			},
			filtergroupChange(devices){
				var self = this;
				return devices.filter(function (d) { 
					if(self.groupfilter =='all'){
						return d;
					}else if(self.groupfilter ==0){
						if(d.group_id==0){						
							return d;					
						}
					}
					else{          
						if(self.groupfilter == d.group_id){						
								return d;							
						}
						
					}
				});
			},
			setTime(e){
				if(e==0){
					this.scheduledata.on_time	= '00:00';			
					this.scheduledata.off_time	=  '00:00';	
					this.scheduledata.on_time_y	= '00:00';			
					this.scheduledata.off_time_y=  '00:00';	
					this.scheduledata.on_time_b	= '00:00';			
					this.scheduledata.off_time_b=  '00:00';	
				}else{				
					let optionindex 			= document.getElementById('groupoption').selectedIndex;
					let groupData 				= this.grouplist[optionindex-1];					
					this.scheduledata.on_time	= groupData.on_time;			
					this.scheduledata.off_time	= groupData.off_time;
					this.scheduledata.on_time_y	= groupData.on_time_y;			
					this.scheduledata.off_time_y= groupData.off_time_y;
					this.scheduledata.on_time_b	= groupData.on_time_b;			
					this.scheduledata.off_time_b= groupData.off_time_b;
				}
			}


	}
}
</script>
<style>

html{
	min-height: 100%;
}
/* body{
	background-color: '#FFF' !important;
	background-image: none !important;
} */
body{
	background-image: url(../assets/home-banner.png) !important;
	background-repeat: no-repeat;
	background-size: cover;
	/* background-position: center center; */
	background-position: bottom;
   
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
}
.table td, .table th{
	vertical-align: middle;
}

.mt-xl{
	margin-top: 100px;
}
.btn-black{
	background-color: #000;
	color: #FFF;
	padding: 6px 25px;
}

.text-bold{
	font-weight: bold;
}
.cont-box {
   
   backdrop-filter: blur(10px);
   -webkit-backdrop-filter: blur(16px);
   height: auto;   
   background: transparent; 
   margin: 23px;
}
.cont-box label{
margin: 0px;
}

.cont-box .container-fluid{
	background: #fff !important;
	border-radius: 5px !important;
}

.cont-box .info-box{
	background-color: #ff9f4333;
}



.text-lg{
	font-size: 18px;
}
.w-15{
	width: 15%;
}
.w-10{
	width: 10%;
}
.w-20{
	width: 20%;
}
.h-10{
	height: 10px !important;
}
.h-15{
	height: 15px !important;
}
.h-20{
	height: 20px !important;
}


.v-select{
    width:auto ;
    height: auto;
    padding-right: 0.75rem;
    background-image: none;
    padding: 0px;
    border: 0px;

}

.v-select-toggle {
    height: calc(1.5em + .5rem + 2px);
    padding-top: .25rem;
    padding-bottom: .25rem;
    padding-left: .5rem;
    font-size: .875rem !important;
}

.v-select .custom-select[multiple], .custom-select[size]:not([size="1"]) {
    height: auto;
    padding-right: .75rem;
    background-image: none;
    width: auto;
}
</style>